import { Vector3 as w } from "three";
import { purgeDuplicates as d } from "../../utils/array/index3.js";
import { isVector3 as D } from "../three/index15.js";
function R(m) {
  let e;
  const h = m.map((o) => D(o)).every((o) => o);
  h ? e = m.map((o) => o.toArray()) : e = m;
  const g = e.slice().sort(function(o, n) {
    return o[0] - n[0] || n[2] - o[2];
  }), H = e.slice().sort(function(o, n) {
    return n[0] - o[0] || n[2] - o[2];
  }), f = [];
  let s = g[0];
  f.push(s);
  for (const o of g.slice(1))
    if (o[0] > s[0] && o[2] >= s[2]) {
      if (o[0] !== s[0] && o[2] !== s[2]) {
        const n = [o[0], s[1], s[2]];
        e.find((t) => t[0] === n[0] && t[2] === n[2]) && f.push(n);
      }
      f.some((n) => n[0] === o[0] && n[2] === o[2]) || (f.push(o), s = o);
    }
  const u = [];
  let r = H[0];
  u.push(r);
  for (const o of H.slice(0))
    if (o[0] < r[0] && o[2] >= r[2]) {
      if (o[0] !== r[0] && o[2] !== r[2]) {
        const n = [o[0], r[1], r[2]];
        e.find((t) => t[0] === n[0] && t[2] === n[2]) && u.push(n);
      }
      u.some((n) => n[0] === o[0] && n[2] === o[2]) || (u.push(o), r = o);
    }
  const A = d([...f, ...u.reverse()]), L = e.slice().sort(function(o, n) {
    return o[0] - n[0] || o[2] - n[2];
  }), a = e.slice().sort(function(o, n) {
    return n[0] - o[0] || o[2] - n[2];
  }), l = [];
  let i = L[0];
  l.push(i);
  for (const o of L.slice(1))
    if (o[0] > i[0] && o[2] <= i[2]) {
      if (o[0] !== i[0] && o[2] !== i[2]) {
        const n = [o[0], i[1], i[2]];
        e.find((t) => t[0] === n[0] && t[2] === n[2]) && l.push(n);
      }
      l.some((n) => n[0] === o[0] && n[2] === o[2]) || (l.push(o), i = o);
    }
  const p = [];
  let c = a[0];
  p.push(c);
  for (const o of a.slice(0))
    if (o[0] < c[0] && o[2] <= c[2]) {
      if (o[0] !== c[0] && o[2] !== c[2]) {
        const n = [o[0], c[1], c[2]];
        e.find((t) => t[0] === n[0] && t[2] === n[2]) && p.push(n);
      }
      p.some((n) => n[0] === o[0] && n[2] === o[2]) || (p.push(o), c = o);
    }
  const U = d([...p, ...l.reverse()]), y = d([...A, ...U]);
  return h ? y.map((o) => new w().fromArray(o)) : y;
}
export {
  R as orthoConvexHull
};
//# sourceMappingURL=index21.js.map
